import { all } from 'redux-saga/effects'
import authFlow from './authFlow'
import watchCheckAuth from './watchCheckAuth'


export default function* authSaga() {
    yield all([
        authFlow(),
        watchCheckAuth()
    ])
}